import StaticPageLayout from 'components/StaticPageLayout'
import { ReactElement, ReactNode } from 'react'
import { Flex, Text } from 'theme-ui'
import UnstyledMarkdown from 'components/UI/UnstyledMarkdown'

export default function StaticContentSkeleton({
  metaDescription,
  metaKeywords,
  title,
  children,
  canonicalUrl,
}: {
  title: string
  metaDescription: string
  metaKeywords: string[]
  children: ReactNode
  canonicalUrl?: string
}): ReactElement {
  return (
    <StaticPageLayout
      title={`Windscribe | ${title}`}
      metaDescription={metaDescription}
      metaKeywords={metaKeywords}
      canonicalUrl={canonicalUrl}
    >
      <Flex
        sx={{
          flexDirection: 'column',
          alignItems: 'center',
          gap: '8rem',
          maxWidth: '100%',
          mb: ['6.4rem', '8rem'],
          mt: ['2.4rem', '4.8rem', '6.4rem'],
          //adds 2.4 on top of the already existing 2.4rem in the StaticPageLayout
          px: [0, '2.4rem', 0],
        }}
      >
        {children}
      </Flex>
    </StaticPageLayout>
  )
}
export function TitledContent({
  title,
  content,
}: {
  title?: string
  content: string
}): ReactElement {
  return (
    <Flex
      sx={{
        flexDirection: 'column',
        gap: '1.6rem',
        width: '100%',
        maxWidth: ['100%', 'maxContentWidth'],
      }}
    >
      {title && <Text variant="text.heading2">{title}</Text>}
      <UnstyledMarkdown sxx={{ variant: 'text.body2', color: 'white50', p: { p: 0, m: 0 } }}>
        {content}
      </UnstyledMarkdown>
    </Flex>
  )
}
